module.exports = __webpack_public_path__ + "img/loading.8aa996af.svg";